<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="核销单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="核销状态">
                            <c-select name="status" :options="CHECK_ORDER_STATUS"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_xiaohei_order_check_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button v-if="auth('b_xiaohei_order_check_create')" prepend-icon="tf-import" @click="$refs.paymentChannelSelector.open()">批量导入</c-button>
                </template>

                <!--收款渠道-->
                <template #check_payment_channel="{data}">
                    <c-state tag async dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
                </template>
                <!--核销状态-->
                <template #status="{data}">
                    <c-state tag async dict="CHECK_ORDER_STATUS" :value="data.status"></c-state>
                </template>
                <!--金额-->
                <template #settlement_amount="{data}">
                    ￥{{data.settlement_amount}}
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="220"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="orderDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_xiaohei_order_check_create') && (data.status == 0 || data.status == 3) && data.check_payment_channel != 1" icon="tf-edit" @click="orderEdit(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_xiaohei_order_check_create') && (data.status == 0 || data.status == 3)" icon="tf-trash" color="red" @click="orderRemove(data)">删除</c-table-button>
                        <c-table-button v-if="auth('b_xiaohei_order_check_examine') && data.status == 2" icon="tf-accept" @click="checkOrderAudit(data)">审核</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <payment-channel-selector ref="paymentChannelSelector" @resolve="payChannelSelectorHandle"></payment-channel-selector>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import paymentChannelSelector from "@/pages/finance/payment_channel_selector.vue";

export default {
    name:'p_finance_saas_deposit_record',

    components: {
        paymentChannelSelector
    },

    data() {
        return {
            workType: 113,
            defaultSearchData: {
            },
            balance:0,
            payEnabled:true,
            ids:[],
            withdraw_account_type:0 //账户类型 1=通联账户  2=三方同售账户
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        ...asyncMapState(['CHECK_ORDER_STATUS'])
    },

    methods: {
        /******选择导入数据支付到响应方法*********/
        payChannelSelectorHandle(data) {
            this.excelImportAnalysis(data);
        },
        /******导入Excel数据**********/
        excelImportAnalysis(data) {
            var paramData = {};
            if (data.check_payment_channel){
                paramData.check_payment_channel = data.check_payment_channel;
            }
            this.globalDialog('excelImportAnalysis', {
                props: {
                    workType: 302
                },
                data: paramData || {}
            }, (import_data_list) => {
                if (import_data_list && import_data_list.length > 0){
                    paramData.import_data_list = import_data_list;
                    this.globalDialog('orderCheckEdit', {
                        props: {},
                        data: paramData || {}
                    }, () => {
                         //刷新页面
                        this.$refs.view.update();
                    });
                }
            });
        },

        /*********打开详情页面**********/
        orderDetail(data) {
            this.globalDialog('orderCheckDetail', {data: data}, () => {
                this.$refs.view.update();
            });
        },
        /**
         * 编辑（仅待核销/审核驳回状态可编辑；通联支付渠道核销单不支持编辑）
         */
        orderEdit(data){
            this.globalDialog('orderCheckEdit', {data: data}, () => {
                this.$refs.view.update();
            });
        },
        /**
         * 删除
         */
        orderRemove(data){
            this.$confirm({
                title: '删除核销单？',
                message: '是否确认删除核销单【'+data.record_number+'】，删除操作不可逆，请谨慎操作！',
                resolve: () => {
                    this.request({
                        url: '/sale/check/remove',
                        data: {
                            id:data.id,
                            status:1
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                message: '删除成功'
                            });
                            this.$refs.view.update();
                        }
                    })
                }
            });
        },
        /**
         * 审核（弹窗确认审核结果：通过/驳回，驳回必须填写原因）
         */
        checkOrderAudit(data){
            this.globalDialog('orderCheckAudit', {data: data}, () => {
                //审核完成后刷新列表
                this.$refs.view.update();
            });
        }
    }
}
</script>


<style lang="stylus" scoped>
.factory {
    border: 1px solid var(--unit-line);
    border-radius: 0 10px 10px 10px;
    border-top: none;
    padding: 26px;
    margin: 0 15px 15px;
    overflow: auto;
    background: #fff;

    &-tab {
        margin: 0 15px;

        >>> ul {
            padding-left: 0;
        }
    }

    &-logo {
        margin-right: 28px;

        &-image {
            position: relative;
            width: 100px;
            height: 100px;
            font-size: 24px;
            color: #ccc;
            background: #242738;

            &:hover {
                color: var(--color-main);

                .factory-logo-handle {
                    display: flex;
                }
            }
        }

        &-handle {
            gap: 20px;
            display: none;
            position: absolute;
            inset: 0;
            font-size: 20px;
            color: #fff;
            background: rgba(0,0,0,.6);

            a {
                font-size: 20px;

                &:hover {
                    color: var(--color-main);
                }
            }
        }

        &-name {
            gap: 5px;
            margin-top: 10px;
            font-size: 13px;
            color: #666;
        }
    }

    &-name {
        height: 32px;
        gap: 12px;

        p {
            font-size: 22px;
            font-weight: bold;
        }

        a {
            font-size: 20px;
            color: var(--color-main);
        }

        input {
            box-sizing: border-box;
            width: 200px;
            height: 100%;
            border: 1px solid #ccc;
            padding: 0 10px;

            &:focus {
                border-color: var(--color-main);
            }
        }

        >>> .c-button {
            height: 32px !important;
        }
    }

    &-code {
        display: inline-block;
        border: 1px solid #ddd;
        border-radius: 15px;
        padding: 0 16px;
        margin-top: 10px;
        line-height: 28px;
        font-size: 14px;
    }

    &-info {
        margin-top: 34px;

        td {
            height: 36px;
            font-size: 14px;

            &:nth-child(1) {
                color: #666;
            }

            &:nth-child(2) {
                padding-left: 20px;
            }

            .edition {
                border-radius: 4px;
                padding: 0 8px;
                margin-right: 10px;
                line-height: 24px;
                font-size: 13px;
                color: #fff;
                background: #F5F5F5;
            }

            .tag {
                border-radius: 4px;
                padding: 0 12px;
                margin: 0 10px;
                line-height: 26px;
                font-size: 15px;
                font-weight: bold;
                background: #F5F5F5;

                span {
                    color: var(--color-main);
                }
            }
        }
    }

    &-handle {
        gap: 20px;
        margin-top: 20px;

        >>> .c-button {
            border-radius: 4px;
        }
    }
}

.templet-list {
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;

    .item {
        width: 300px;
        border-radius: 6px;
        overflow: hidden;
        background: #F9F9F9;
        transition: box-shadow .3s ease;

        &:hover {
            box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
        }

        .cover {
            height: 200px;
            overflow: hidden;

            .image {
                height: 100%;
                background-size: cover;
                background-position: center;
                transition: transform .3s ease;

                ^[-2]:hover ^[-2..-1] {
                transform: scale(1.2);
            }
            }
        }

        .info {
            padding: 6px 25px 0;

            h5 {
                line-height: 50px;
                font-size: 18px;
            }

            ul {
                li {
                    position: relative;
                    padding: 6px 0 6px 24px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;

                    .tf {
                        position: absolute;
                        left: 0;
                        top: 0;
                        line-height: 32px;
                        font-size: 15px;
                        color: var(--color-main);
                    }
                }
            }
        }

        .button {
            padding: 16px 0 20px;

            >>> .c-button {
                width: 108px;
                height: 36px !important;
            }
        }
    }
}

.data-type {
    gap: 15px;
    padding: 20px;

    li {
        position: relative;
        border: 1px solid #F5F5F5;
        border-radius: 4px;
        padding: 20px;
        background: #F5F5F5;
        cursor: pointer;

        h5 {
            margin-bottom: 14px;
            font-size: 16px;
            font-weight: normal;
        }

        p {
            line-height: 22px;
        }

        &.z-crt,
        &:hover {
            border-color: var(--color-main);
            background: #fff;
        }

        &.z-crt {
            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border-top: 24px solid var(--color-main);
                border-left: 28px solid rgba(0,0,0,0);
            }

            &:after {
                content: '\e63f';
                position: absolute;
                right: 2px;
                top: 2px;
                font-family: 'iconfont';
                font-size: 10px;
                color: #fff;
            }
        }
    }
}

.notice {
    &-delete {
        padding: 5px;
        font-size: 15px;
        color: #f00;

        &:hover {
            border-radius: 4px;
            background: #F5F5F5;
        }
    }

    &-temp {
        height: 520px;

        &-tip {
            margin-left: 20px;
        }
    }

    &-guide {
        align-self: flex-start;
        position: sticky;
        top: 0;
        padding: 26px 30px 20px;
        background: #FAFAFA;

        &-tip {
            margin-bottom: 12px;
            font-size: 13px;
            color: #f55;
        }

        &-arrow {
            position: relative;
            width: 60px;
            height: 1px;
            margin: 90px 16px 0;
            background: #999;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: -5px;
                border-left: 10px solid #999;
                border-top: 5px solid rgba(0,0,0,0);
                border-bottom: 5px solid rgba(0,0,0,0);
            }
        }

        &-item {
            width: 180px;

            img {
                height: 180px;
            }

            p {
                margin: 14px 0 10px;
                font-size: 14px;
                font-weight: bold;
                white-space: nowrap;
                color: #f55;
            }

            span {
                line-height: 20px;
                font-size: 13px;
                color: #999;
            }
        }
    }
}
</style>